import { render } from "./IncidentAlert.vue?vue&type=template&id=5912924f&scoped=true"
import script from "./IncidentAlert.vue?vue&type=script&lang=js"
export * from "./IncidentAlert.vue?vue&type=script&lang=js"

import "./IncidentAlert.vue?vue&type=style&index=0&id=5912924f&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3389461850/src/acx.portal/Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5912924f"]])

export default __exports__